export enum EnumCheckoutStatus {
  INITIATED = "INITIATED",
  CREATED = "CREATED",
  THREEDS_VALIDATION_REQUESTED = "3DS_VALIDATION_REQUESTED",
  THREEDS_APPROVED = "3DS_APPROVED",
  THREEDS_REPROVED = "3DS_REPROVED",
  THREEDS_ERROR = "3DS_ERROR",
  RISK_ANALYSIS_STARTED = "RISK_ANALYSIS_STARTED",
  RISK_ANALYSIS_APPROVED = "RISK_ANALYSIS_APPROVED",
  RISK_ANALYSIS_REPROVED = "RISK_ANALYSIS_REPROVED",
  CHARGE_WAITING = "CHARGE_WAITING",
  CHARGE_SUCCEEDED = "CHARGE_SUCCEEDED",
  CHARGE_NOT_SUCCEEDED = "CHARGE_NOT_SUCCEEDED",
  PAYMENT_WAITING = "PAYMENT_WAITING",
  PAYMENT_STARTED = "PAYMENT_STARTED",
  PAYMENT_DONE = "PAYMENT_DONE",
  PAYMENT_ERROR = "PAYMENT_ERROR",
  COMPLETED = "COMPLETED",
  IN_DISPUTE = "IN_DISPUTE",
  CHARGEBACK = "CHARGEBACK",
  REVERSED = "REVERSED",
  REMOVED = "REMOVED",
}

export type CreateClientRequest = {
  name: string;
  document: string;
  email: string;
  phone: string;
  address: {
    address: string;
    number: string;
    neighborhood: string;
    zip_code: string;
    city: string;
    state: string;
    complement?: string;
  };
};
export type CreateClientResponse = {
  id_client: string;
  name: string;
  document: string;
  email: string;
  phone: string;
  address: {
    address: string;
    city: string;
    complement: null;
    neighborhood: string;
    number: string;
    state: string;
    zip_code: string;
  };
  created_at: string;
};

export type CreateCheckoutRequest = {
  id_client: string;
  charges: {
    id_charge_option: string;
    card?: {
      number: string;
      exp_month: string;
      exp_year: string;
      security_code: string;
      holder_name: string;
      three_ds?: {
        provider: string;
        id: string;
        encrypt_card: string;
      };
    };
  }[];
};
export type CreateCheckoutResponse = {
  error?: EnumCheckoutErrorResponse;
  id_checkout: string;
  id_status: EnumCheckoutStatus;
  client_id: string;
  establishment_id: string;
  type: string;
  amount: number;
  fee_amount: number;
  total_amount: number;
  created_at: string;
  charges: {
    id_charge: string;
    bill_code: string;
    pix_qr_code: string;
    due_date: string;
  }[];

  // 3ds challenge
  challenge_url?: string;
  credential_request?: string;
};

export interface CreateChargeResponse {
  id_charge: string;
  id_status: string;
  id_card: string;
  checkout_id: string;
  type: string;
  source: string;
  channel: string;
  provider_code: string;
  provider_name: string;
  provider_authorization_code: string;
  nsu_code: string;
  acquirer: string;
  psp: string;
  bill_code: string;
  pix_qr_code: string;
  authorizer_nsu: string;
  authorizer: string;
  authorization_number: string;
  card_last_four_digits: string;
  card_brand: string;
  card_input_method: string;
  card_requested_password: boolean;
  amount_total: number;
  installment_number: number;
  installment_amount: number;
  due_date: string;
  created_at: string;
  updated_at: string;
  id_three_ds: string;
  challenge_url: string;
  credential_request: string;
}

export enum EnumCheckoutErrorResponse {
  CHARGE_OPTIONS_EXPIRED = "checkout.error.charge-options.expired",
}

export type CreateCheckoutOrder3dsResponse = {
  id_three_ds: string;
  first_four_digits?: string;
  last_four_digits?: string;
  validation_method_token?: string;
  validation_method_url?: string;
  error: boolean;
  message?: string;
  code: string;
};
type GetBrowserDataRes = {
  browser_user_agent: string;
  browser_java_enabled: string;
  browser_javascript_enabled: string;
  browser_language: string;
  browser_color_depth: string;
  browser_screen_height: string;
  browser_screen_width: string;
  browser_tz: string;
};
export type CreateCheckout = {
  token: string;
  id_establishment: string;
  browserInfoHeaders?: GetBrowserDataRes;
  payload: CreateCheckoutOrderRequest;
};

export interface CreateChargeRequestDTO {
  id_charge_option: string;
  client: {
    id_client: string;
    name: string;
    email: string;
    document: string;
    phone: string;
  };
  card?: Card;
  is_down_payment?: true;
}

export interface Card {
  number: string;
  exp_month: string;
  exp_year: string;
  security_code: string;
  holder_name: string;
  three_ds?: ThreeDs;
}

export interface ThreeDs {
  provider: string;
  id: string;
  encrypt_card?: string;
  validation_time_to_complete?: number;
}

export type CreateChargeRequest = {
  payload: CreateChargeRequestDTO;
  id_charge: string;
  id_establishment: string;
  browserInfoHeaders?: GetBrowserDataRes;
  token: string;
};

export type CreateCheckout3dsConfirm = CreateCheckout & {
  id_checkout: string;
};

export type CreateCheckout3DS = Omit<CreateCheckout, "browserInfoHeaders">;

export type CreateCheckoutOrderRequest = {
  id_client: string;
  charges: CheckoutOrderRequest[];
};

export type CheckoutOrderRequest = {
  id_charge_option: string;
  card?: {
    number: string;
    exp_month: string;
    exp_year: string;
    security_code: string;
    holder_name: string;
    id_three_ds?: string;
    three_ds?: ThreeDs;
  };
};
export interface ThreeDs {
  provider: string;
  id: string;
  encrypt_card?: string;
  validation_time_to_complete?: number;
}

export type ThreeDSPublicKeyResponse = {
  public_key: string;
};
